import { Locale } from './types';

export const pl: Locale = {
  hero: {
    desc: "Pęknąć na rowerze 50 km od domu to żaden heroizm - to szkolny błąd w obliczeniach. Zamiast dzwonić po podwózkę, rozegraj to mądrzej. Broom Wagon przelicza Twój ślad GPX i waty na strategię, dzięki której będziesz miał z czego kręcić do samego końca. Kończ każdą jazdę o własnych siłach.",
    tagline: 'Kolarska inżynieria, romantyczna przygoda. By dzień kończył się zachodem słońca, a nie odcięciem prądu.',
    free: 'Zupełnie za darmo. Bo wiemy, że waty i sprzęt kosztują wystarczająco dużo.',
  },
  motto: 'Śmieciarka? Nie tym razem!',
  tabs: {
    walkthrough: 'Jak to działa',
    ecosystem: 'W trakcie jazdy',
    science: 'Pod maską',
    broomWagon: 'Historia nazwy',
  },
  lore: {
    heading: 'Czym jest ten cały Broom Wagon?',
    paragraphs: [
      'Wóz z miotłą (franc. voiture lub camion balai) od ponad wieku wlecze się na końcu peletonu. Jego zadanie? Dosłowne zgarnianie z trasy kolarzy, którzy się wycofali lub pękli na podjeździe.',
      'W amatorskim świecie ta legendarna „śmieciarka” przybiera gorsze formy: błagalny telefon do żony, absurdalnie droga taksówka albo wleczenie się w butach z blokami na lokalny pociąg.',
      'Nasza aplikacja to Twoja polisa ubezpieczeniowa. Jedz zgodnie z planem, trzymaj waty, a niech śmieciarka zbiera z trasy kogoś innego. <a href="https://www.velominati.com/commentary/the-rules/#5" target="_blank" rel="noreferrer" style="color: #c4cdd5; text-decoration: underline; text-underline-offset: 2px;" onmouseover="this.style.color=\'#fff\'" onmouseout="this.style.color=\'#c4cdd5\'">Reguła #5</a> nadal obowiązuje, ale głodowanie na rowerze to żaden powód do dumy.',
    ],
    linksLabel: 'POCZYTAJ WIĘCEJ O HISTORII:',
  },
  storyItems: [
    {
      label: 'Wgraj trasę',
      desc: 'Wrzuć plik GPX. My zajmiemy się matematyką - przeczytamy każdy podjazd, zjazd i wyciągniemy z tego czystą fizykę Twojego cierpienia.',
      alt: 'Wgrywanie GPX',
    },
    {
      label: 'Skalibruj silnik',
      desc: 'Waga, FTP i cel: od niedzielnego coffee ride’u po jazdę „w trupa”. Wyliczymy dokładnie, ile węgli dziś spalisz.',
      alt: 'Opcje strategii',
    },
    {
      label: 'Zaplanuj bufety',
      desc: 'Algorytm pokaże Ci optymalne okna na jedzenie. Przesuwaj je dowolnie, żeby zgrać je z pit-stopem na stacji benzynowej.',
      alt: 'Edytor punktów tankowania',
    },
    {
      label: 'Spakuj kieszonki',
      desc: 'Wybierz ulubione żele i batony. Rozdzielimy je tak, byś nie musiał jeść w kółko tego samego smaku i idealnie trafić w zapotrzebowanie.',
      alt: 'Wybór produktów',
    },
    {
      label: 'Zapomnij o bombie',
      desc: 'Odbierz gotowy rozkład jazdy. Koniec zgadywania. Wiesz co i kiedy zjeść, żeby Broom Wagon musiał szukać kogoś innego.',
      alt: 'Wyniki planu żywienia',
    },
  ],
  why: [
    {
      title: 'To nie jest głupia tabelka 60g/h',
      desc: 'Twój organizm nie wie, co to średnia. 10% nachylenia przy 300W to nie to samo co kręcenie w tlenie na kole. Nasz silnik przelicza opory toczenia, aero i grawitację na czyste węgle. Ryzykuj w ucieczkach, nie w bufecie.',
    },
    {
      title: 'Reguła #X: Bufet to Twój czysty „sok”',
      desc: 'Głodówka na rowerze to żaden powód do dumy – to po prostu błąd w obliczeniach. Z precyzyjnym planem utrzymasz moc wtedy, kiedy inni pękają. Cierp dlatego, że jedziesz szybko, a nie dlatego, że zapomniałeś zjeść.',
    },
    {
      title: 'Wykrywacz bomby',
      desc: 'Algorytm śledzi Twój bilans energetyczny kilometr po kilometrze. Jeśli matematyka mówi, że na tej przełęczy odetnie Ci prąd, Broom Wagon zapali czerwoną lampkę zanim w ogóle wyjdziesz z domu.',
    },
    {
      title: 'Fizjologia bez doktoratu',
      desc: 'Limity absorpcji jelitowej (SGLT1/GLUT5), utlenianie węglowodanów w strefach mocy i spalanie glikogenu. Cała naukowa nuda schowana pod maską, żebyś Ty dostawał tylko proste komendy: kiedy i co włożyć do ust.',
    },
  ],
  sticker: {
    desc: 'Czysty kokpit, czysta głowa. Wygeneruj naklejkę na rurę górną z gotowym harmonogramem i profilem trasy. Twój licznik ma wyświetlać tylko to, co ważne: Prędkość, Dystans i Cierpienie.',
  },
  integrations: {
    intro: 'Naklejka na rurę to wolność od elektroniki i namacalna strategia, która nie potrzebuje baterii. Jeśli jednak wolisz cyfrowy kokpit, budujemy bezpośrednią integrację z Garminem, Wahoo i aplikacją z alertami.',
    comingSoon: 'WKRÓTCE',
    comingSoonDesc: 'Broom Wagon to niezależny projekt, a integracje sprzętowe to nasz kolejny duży cel. Jeśli chcesz pokazać, że nasze narzędzie sprawdza się na Twoich trasach - postaw nam wirtualną kawę albo podrzuć pomysł na nową funkcję. To dla nas najlepszy znak, że jedziemy w dobrym kierunku.',
    items: [],
  },
  science: {
    title: 'Pod maską',
    intro: 'Broom Wagon jest oparty na sprawdzonych modelach z fizjologii wysiłku i biomechaniki kolarskiej - nie heurystykach ani tabelkach.',
    sections: [
      {
        title: 'Model mocy',
        desc: 'Dla każdego segmentu GPX wyliczamy mechaniczną moc wyjściową. Grawitacja, wiatr i opory toczenia kontra Twoje nogi. Wynik? Profil trasy wat po wacie, niczym w profesjonalnym sofcie analitycznym.',
      },
      {
        title: 'Węgle według stref',
        desc: 'Jazda w tlenie (Z1-Z2)? Palisz głównie tłuszcz. Powyżej progu (Z4+)? Węglowodany stają się paliwem lotniczym. Aplikacja mapuje trasę na strefy Coggana i podbija zapotrzebowanie na podjazdach.',
      },
      {
        title: 'Limity Twoich jelit',
        desc: 'Zwykła glukoza zatyka się w jelitach przy ok. 60 g/h (transporter SGLT1). Dorzucasz fruktozę (GLUT5) i nagle przepychasz 90 g/h. Pilnujemy tych limitów, żebyś nie skończył z rewolucją żołądkową w rowie.',
      },
      {
        title: 'Opróżnianie baku',
        desc: 'Twoje zapasy glikogenu to raptem 400-600 gramów. Broom Wagon na bieżąco sprawdza, ile spalasz, a ile przyjmujesz, ostrzegając Cię o nieuchronnym odcięciu prądu na długo przed kryzysem.',
      },
    ],
    referencesLabel: 'ŹRÓDŁA',
    statsLabel: 'Kluczowe liczby',
    stats: [
      { value: '60 g/h',    label: 'Standardowy protokół',  sub: 'Dobry na przejażdżkę po bułki, ale za krótki na Alpy.',        tooltip: 'Górna granica przyswajania samej glukozy. Bezpieczna dawka dla większości kolarzy, która nie wymaga specjalnego przygotowania żołądka, ale na wyścigach może nie wystarczyć.' },
      { value: '90 g/h',    label: 'Hartowanie jelita',      sub: 'Twoje jelita muszą się nauczyć przyjmować tyle paliwa, co Twój silnik.', tooltip: 'Wymaga miksu glukozy i fruktozy (np. 1:0.8). Powyżej 60g/h organizm musi korzystać z różnych transporterów paliwa. Jelita trzeba do tego przyzwyczaić na treningach, by uniknąć problemów żołądkowych.' },
      { value: '400-600 g', label: 'Twój kapitał',          sub: 'Gdy spadnie do zera, jedynym Twoim napędem będzie siła woli i Broom Wagon.', tooltip: 'Zapas glikogenu zmagazynowany w nogach i wątrobie. To Twoja „bateria", którą systematycznie opróżniasz. Gdy licznik pokaże zero, czeka Cię Broom Wagon – chyba że doładujesz węgle na czas.' },
      { value: 'Z4+',       label: 'Punkt bez powrotu',     sub: 'Tu spalasz węgle szybciej, niż jesteś w stanie je przełykać. Planuj mądrze.', tooltip: 'Powyżej progu mleczanowego organizm niemal całkowicie rezygnuje ze spalania tłuszczu na rzecz glikogenu. W tej strefie każda minuta bez jedzenia przybliża Cię do bomby.' },
    ],
    sciencePromo: 'Twój organizm nie wie, co to średnia. Nasz silnik przelicza opory toczenia, aero i grawitację na czyste węgle. Ryzykuj w ucieczkach, nie w bufecie.',
    loginRequired: 'Zaloguj się, aby uzyskać dostęp do pełnego opisu modelu fizycznego i fizjologicznego.',
  },
  signin: {
    prompt: 'Zaloguj się lub utwórz bezpłatne konto, żeby zacząć.',
  },
  nav: {
    planner: 'Planer',
    history: 'Historia (Wkrótce)',
    products: 'Produkty (Wkrótce)',
    settings: 'Ustawienia',
    account: 'Konto',
    manual: 'Instrukcja obsługi',
    manualComingSoon: 'Instrukcja jest w przygotowaniu. Wróć wkrótce.',
    about: 'O nas',
    support: 'Wesprzyj nas',
    logout: 'Wyloguj się'
  },
  support: {
    heading: 'Wesprzyj projekt',
    sections: [
      {
        title: 'Kto za tym stoi',
        desc: 'Jesteśmy ekipą, która przed jazdą maniakalnie sprawdza kierunek wiatru, ciśnienie w oponach i VAM. Mamy nieuleczalną obsesję na punkcie danych, ale to rower zawsze jest na pierwszym miejscu. Broom Wagon zrobiliśmy dla siebie, za własne pieniądze żeby po prostu nie zgasnąć na trasie.',
      },
      {
        title: 'Co jest i zostanie darmowe',
        desc: 'Upload GPX, pełny model energetyczny, planer żywieniowy, wykrywanie bomby, naklejka na ramę - to wszystko jest bezpłatne i takie pozostanie. To nasz wkład dla społeczności kolarskiej.',
      },
      {
        title: 'Waty kosztują',
        desc: 'Działamy niezależnie, co daje nam wolność w budowaniu najlepszego narzędzia dla kolarzy. Twoje wsparcie pomaga nam utrzymać to tempo i pokryć koszty infrastruktury, by Broom Wagon stawał się coraz lepszy.',
      },
    ],
    actionsLabel: 'Jak możesz pomóc',
    actions: [
      { label: 'Postaw kawę', desc: 'Jednorazowe wsparcie przez Buy Me a Coffee. Każda kawa to godziny developmentu.' },
      { label: 'Podziel się', desc: 'Powiedz o Broom Wagon innym kolarzom. Polecenie znajomemu to też ogromna wartość.' },
      { label: 'Napisz do nas', desc: 'Feedback, pomysły, błędy - każda wiadomość pomaga nam budować lepszy produkt.' },
    ],
    shareTweet: 'Jak planujecie żywienie na długie trasy? Znalazłem apkę, która przelicza waty i GPX na konkretne gramy węgli. Może być ciekawie.',
    linksLabel: 'WESPRZYJ PROJEKT:',
  },
  about: {
    heading: 'Broom Wagon',
    desc: 'Niezależny projekt zbudowany z pasji do danych i nienawiści do kolarskiej „bomby”. Skup się na widokach i bólu. My policzymy węgle żebyś nigdy nie pękł zanim dojedziesz do celu.',
    contactLabel: 'Kontakt',
    email: 'contact@broomwagon.app',
    followLabel: 'Obserwuj nas',
  },
  settings: {
    language: {
      heading: 'Język',
    },
    cyclist: {
      heading: 'Profil kolarza',
      ftp: 'FTP (waty)',
      ftpPlaceholder: 'Twój próg wydajności',
      weight: 'Waga (kg)',
      weightPlaceholder: 'Twoja waga',
      maxAbsorption: 'Tolerancja węgli (g/h)',
      gelsPerHourHint: '≈ {count} żelu na godzinę (25g/żel)',
    },
    bike: {
      heading: 'Rower',
      weight: 'Waga roweru (kg)',
    },
    save: 'Zapisz ustawienia',
    saving: 'Zapisuję...',
    saved: 'Ustawienia zapisane',
  },
  planner: {
    strategyOptions: 'Opcje strategii',
    strategyGroups: {
      intensity: 'Intensywność i Czas',
      fuelModel: 'Model Paliwowy',
    },
    targetZone: 'Strefa docelowa',
    frequency: 'Jedz co (min):',
    frequencyHint: 'Określ, co ile minut planujesz przyjmować żele/bufet.',
    safetyMargin: 'Margines błędu (Overfueling)',
    safetyMarginDescriptions: [
      { min: 0, max: 5, text: 'Płyniesz z prądem. Optymalne wchłanianie.' },
      { min: 6, max: 15, text: 'Agresywne ładowanie. Ryzykujesz lekki dyskomfort, ale oddalasz bombę.' },
      { min: 16, max: 100, text: 'Strefa zagrożenia. Upewnij się, że Twoje jelita to wytrzymają.' },
    ],
    proModeWarning: 'Wchodzisz w tryb Pro. Bez fruktozy i \'treningu jelita\' czeka Cię postój w krzakach.',
    cyclistProfile: 'Profil kolarza',
    edit: 'Edytuj',
    close: 'Zamknij',
    back: 'Wróć',
    nextStep: 'Następny krok',
    cyclist: {
      ftp: 'FTP',
      weight: 'Waga',
      bike: 'Rower',
    },
    steps: {
      routeAnalysis: 'Analiza trasy',
      strategyOptions: 'Opcje strategii',
      fuelPoints: 'Punkty tankowania',
      products: 'Produkty',
      fuelPlan: 'Plan żywienia',
      summary: 'Podsumowanie',
    },
    gpx: {
      uploadPrompt: 'Dodaj plik .gpx (przeciągnij lub kliknij)',
      analyzing: 'Analizuję...',
      distance: 'Dystans',
      elevationGain: 'Podjazdy',
      elevationLoss: 'Zjazdy',
      segments: 'Segmenty',
      chartLabel: 'Dystans (km)',
      elevationLabel: 'Wysokość',
    },
    chartHint: 'Kliknij, aby dodać',
    products: {
      name: 'Nazwa',
      carbs: 'Węglowodany',
      type: 'Typ',
      qty: 'Ilość',
      minPortion: 'Min. porcja',
      whole: 'całość',
      carbsUnit: 'Węglowodany (g)',
      qtyUnit: 'Ilość',
      minPortionUnit: 'Min. porcja (g)',
      save: 'Zapisz',
      cancel: 'Anuluj',
      verified: 'Zweryfikowany przez partnera',
      edit: 'Edytuj produkt',
      delete: 'Usuń produkt',
      partnerStore: 'Przejdź do sklepu partnera',
      placeholderName: 'Nazwa',
      resetDefaults: 'Przywróć domyślne',
      addProduct: '+ Dodaj produkt',
      partnerModalText: 'Ten produkt pochodzi od zaufanego partnera. Możesz odwiedzić ich sklep, aby nabyć',
      partnerModalComingSoon: 'Wkrótce będzie możliwe bezpośrednie przejście do sklepu partnera.',
    },
    summary: {
      route: 'Trasa',
      distance: 'Dystans',
      duration: 'Czas jazdy',
      elevationGain: 'Podjazdy',
      elevationLoss: 'Zjazdy',
      fuelPoints: 'Punkty tankowania',
      packingList: 'Do Zapakowania',
      cyclistProfile: 'Profil Kolarza',
      ftp: 'FTP',
      weight: 'Waga',
      zone: 'Strefa',
      strategy: 'Strategia',
      refuelEvery: 'Tankowanie co',
      maxAbsorption: 'Max absorpcja',
      maxSurplus: 'Max nadwyżka',
      maxDeficit: 'Max deficyt',
      generateSticker: 'Generuj naklejkę',
      stickerTitle: 'Fuel Plan Sticker',
      downloadSvg: 'Download SVG',
    },
    stats: {
      carbs: 'Węglowodany',
      balance: 'Bilans',
      average: 'Średnia',
      burned: 'spalonych',
    },
  },
  mobileFootnote: 'Analiza watów wymaga przestrzeni. Planer zoptymalizowany pod duże ekrany. Mobilny pomocnik w drodze.',
  langToggle: 'EN',
  footerHeading: 'Grupetto',
};
